var SwiperTransformation = {
    init:function(){
        var swiper = new Swiper(".slider-transformation .swiper-container", {
            slidesPerView:'auto',
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false,
                draggable: true,
              },
              
          });
    }
}

$(window).load(function(){
    if($('.slider-transformation').length){
        SwiperTransformation.init();
    }
})